.select-with-icon-option {
    display: flex;
    align-items: center;
}

.label {
    font-size: var(--font-small);
    margin-left: 6px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right: 6px;
}
